module.exports = __webpack_public_path__ + "img/device-active.fbe7b361.svg";